<template>
  <html lang="pt-br">
    <head>
      <meta name="description" content="Conheça o Instituto Brasileiro de Ciências em Gestão Pública - ">

      <component-head-style/>
    </head>

    <body class="body-wrapper" data-spy="scroll" data-target=".privacy-nav">
      <component-nav-bar/>

      <about-data/>

      <component-footer/>

      <btn-to-top/>
    </body>

    <component-body-scripts/>
  </html>
</template>

<script>
  import Head from '../structure/Head.vue';
  import Navbar from '../structure/Navbar.vue';

  import AboutData from './Data.vue';
  
  import Footer from '../structure/Footer.vue';
  import BtnToTop from '../structure/BtnToTop.vue';
  import BodyScripts from '../structure/BodyScripts.vue';

  export default {
    created(){
      document.title = "IBCGP | Conheça o Instituto";
    },
    components:{
      'component-head-style'    : Head,
      'component-nav-bar'       : Navbar,

      'about-data'              : AboutData,

      'component-footer'        : Footer,
      'btn-to-top'              : BtnToTop,
      'component-body-scripts'  : BodyScripts
    },
  }
</script>